// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".who_can_see_this-module__container--3xp87{min-width:120px}.who_can_see_this-module__text--3P5oE{font-weight:400;font-size:14px;line-height:21px;letter-spacing:0;font-variant:all-small-caps}\n", ""]);
// Exports
exports.locals = {
	"container": "who_can_see_this-module__container--3xp87",
	"text": "who_can_see_this-module__text--3P5oE"
};
module.exports = exports;
